module.exports = __WEBPACK_EXTERNAL_MODULE_54__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"mocha","commonjs":"mocha","commonjs2":"mocha","root":"mocha"}
 ** module id = 54
 ** module chunks = 1 2
 **/